import { useLazyQuery } from '@apollo/client';
import { exportXlsModal } from 'motion-components';
import { gqlGetQuery } from '../graphql';
import { buildWhereFromFilterValues } from './filters';
import { useState } from 'react';
import { format, parseISO } from 'date-fns';
import { Company, isRebattery } from 'shared-pages/common/constants';

export const exportColumns = (t) => {
  return [
    // { fieldName: "id", fieldTitle: "Id", fieldType: "TEXT" },
    { fieldName: 'id', fieldTitle: t('ID'), fieldType: 'TEXT' },
    { fieldName: 'name', fieldTitle: t('Ονοματεπώνυμο Οδηγού'), fieldType: 'TEXT' },
    { fieldName: 'collector.name', fieldTitle: t('Συλλέκτης'), fieldType: 'TEXT' },
    ...(!isRebattery ? [{ fieldName: 'phone', fieldTitle: t('Τηλέφωνο'), fieldType: 'TEXT' }] : []),

    { fieldName: 'adrNumber', fieldTitle: t('Αριθμός ADR'), fieldType: 'TEXT' },
    { fieldName: 'adrExpDate', fieldTitle: t('Λήξη ADR'), fieldType: 'DATE' },
    { fieldName: 'isActive', fieldTitle: t('Ενεργή Εγγραφή'), fieldType: 'TEXT' },
    { fieldName: 'firstRec', fieldTitle: t('Δήλωση'), fieldType: 'TEXT' },
    { fieldName: 'lastRec', fieldTitle: t('Αλλαγή'), fieldType: 'TEXT' },
  ];
};

export async function handleExport(client, queryState: any, t): Promise<void> {
  function useGetQuery() {
    const [get, { loading }] = useLazyQuery(gqlGetQuery, { onCompleted: transformData });
    const [result, setResult] = useState<any>([get, { loading, data: undefined }]);
    function transformData(data) {
      const recs = data.getDrivers.data.map((values) => {
        return {
          ...values,
          isActive: !values.isActive ? t('ΟΧΙ') : t('ΝΑΙ'),
          firstRec: ` ${
            values.firstDate ? format(parseISO(values.firstDate), 'dd/MM/yy HH:mm') : ''
          }  - ${values.firstUser}`,
          lastRec: ` ${
            values.lastDate ? format(parseISO(values.lastDate), 'dd/MM/yy HH:mm') : ''
          }  - ${values.lastUser}`,
        };
      });
      const trsData = {
        getDrivers: { data: recs, recordCount: data?.getDrivers?.recordCount },
      };
      setResult([get, { loading, data: trsData }]);
    }
    return result;
  }
  const filterVariables = {
    where: buildWhereFromFilterValues(queryState?.filterValues),
  };
  await exportXlsModal({
    apolloClient: client,
    exportFileName: 'export Drivers',
    getLazyQuery: useGetQuery,
    columnsDef: exportColumns(t),
    filterVariables: filterVariables,
  });
}

